// src/context/ReadonlyStore.ts
var writableStore = (store) => {
  return store;
};
export {
  writableStore
};
//# sourceMappingURL=ReadonlyStore.mjs.map